module.exports = __webpack_public_path__ + "img/bg_lv_pc.75d9b62f.png";